// removed by extract-text-webpack-plugin
module.exports = {"viewport":"_3TIC8DdLPWZp6zaphOadnq","sidebar":"l6gKeyc38bLpRfRckRhvj","header-row":"_3BB8A2gLTUHo_SIEWdSgRJ","header-column":"_2ifKYS41bLZ5rpGTQArnbj","footer":"_1yKibJhG6BOa1BH-VdhIYb"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/CoreLayout/CoreLayout.scss
// module id = 1177
// module chunks = 1